<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Products List</mat-card-title>
    
   <button  mat-fab  [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'" (click)="onAddProduct()"  
     [disabled] ="!isAdminGroupUser" style="position:absolute; right:10px;top:8px;width: 35px; height:35px;">  
     <span class="mat-button-wrapper">
       <i _ngcontent-c4="" class="material-icons" style="font-size:30px;">add</i>
     </span>
    
   </button>
   <button mat-fab  (click)="exportExcel()"  color="accent" style="position: absolute;right: 50px;top: 8px;width: 35px; height:35px;"
   *ngIf="products != null && products.length >0" matTooltip="Download Records">
   <span class="mat-mdc-button-wrapper">
     <i   class="material-icons" style="font-size:30px;">download</i>
   </span>
 </button>
    
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <div class="row">
        <div class="col-md-9">
        </div>
        <div class="col-md-3">
           <app-filter-input *ngIf="products!=null && products.length >0" (filterChanged)="applyFilter($event)"></app-filter-input>
        </div>
      </div>
       <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
        (matSortChange)="announceSortChange($event)" *ngIf="products!=null && products.length >0" 
         aria-label="Table listing products">
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef>S No. </th>
          <td mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </td>
        </ng-container>

        <!-- productId Column -->
        <ng-container matColumnDef="productId">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element"> {{element.productId}} </td>
        </ng-container>
        <!-- warehouseName Column -->
        <ng-container matColumnDef="productName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by productName"> Product
            Name </th>
          <td mat-cell *matCellDef="let element"> {{element.productName}} </td>
        </ng-container>

        <!-- description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by description"> Description
          </th>
          <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>
        <!-- cityId Column -->
        <ng-container matColumnDef="isActive">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by isActive"> Active </th>
          <td mat-cell *matCellDef="let element"> {{element.isActive}} </td>
        </ng-container>

        <!-- warehouseManagerId:  Column -->
        <ng-container matColumnDef="isDeleted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by isDeleted"> Deleted </th>
          <td mat-cell *matCellDef="let element"> {{element.isDeleted }} </td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Edit </th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab aria-label="Delete"  [disabled] ="!isAdminGroupUser" (click)="updateProduct($event, element)">
              <mat-icon>create</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef> Delete </th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab aria-label="Delete" [disabled] ="!isAdminGroupUser" (click)="OnDeleteProduct($event, element)" color="warn">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
     
      <div *ngIf="isLoaderResult"  class="custSpinner"> 
      </div>
      </div>
       <mat-paginator [length]=resultLength [pageSize]="25" [pageSizeOptions]="[ 25, 50, 100]"  aria-label="Select page"></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>